import navigation from '../navigation/rbmc.navigation';
import urlUtils from '../utils/rbmc.url-utils';
import logger from '../utils/rbmc.logger';
import spinner from '../utils/rbmc.spinner';

const voucherHandling = {

    handleVoucherAdd() {
        const voucherInputField = $('.cart-voucher__input-field');
        const voucherCode       = voucherInputField.val();
        spinner.spinnerVisibility(true);
        $.post(urlUtils.getBaseUrl() + 'cart/addvoucher/', {voucherCode: voucherCode}, null)
         .done(function (response) {
             logger.debug('Voucher add call success');
             if (response.success === true) {
                 window.location.reload();
             } else {
                 logger.debug('Wrong Voucher');
                 $('.cart-voucher__message-text--error').text(response.message);
                 $('.cart-voucher').addClass('cart-voucher--invalid');
             }
             voucherInputField.val('');
         })
         .fail(function (x, e) {
             logger.error('Voucher add call failed');
         })
         .always(() => spinner.spinnerVisibility(false));
    },

    handleVoucherDeletion(voucherValue, urlFragment) {
        spinner.spinnerVisibility(true);
        let request = $.ajax({
            url:         `${urlUtils.getBaseUrl()}cart/` + urlFragment,
            method:      'POST',
            dataType:    'json',
            contentType: 'application/json',
            data:        JSON.stringify({
                voucherCode: voucherValue
            })
        });

        request.done((response) => {
            spinner.spinnerVisibility(true);
            if (response.success === true) {
                window.location.reload();
            } else {
                $('.cart-voucher__message-text--error').text(response.message);
                $('.cart-voucher').addClass('cart-voucher--invalid');
            }
        });
        request.fail((jqXHR) => {
            logger.error(`${jqXHR.status} error in voucherHandling.handleVoucherDeletion`);
            window.location.reload();
        });

        request.always(() => spinner.spinnerVisibility(false));
    },

    setupVoucherHandling() {
        const tooltipMarkup   = $('.cart-voucher__tooltip-markup').html();
        const tooltipSettings = {
            placement: 'bottom',
            trigger:   'manual',
            template:  tooltipMarkup,
            sanitize:  false
        };
        let tooltip           = undefined;

        $(document).on('click', '.js-cart-voucher__delete', function (e) {
            tooltip = $(e.currentTarget);
            tooltip.tooltip(tooltipSettings);
            tooltip.tooltip('show');
            navigation.setGreyout(true);
            tooltip.closest('.cart-voucher__code--inner').addClass('cart-voucher__input--highlighted');
        });

        $(document).on('click', '.cart-voucher__tooltip-button', function (e) {
            e.preventDefault();
            if ($(this).attr('id').indexOf('yes') >= 0) {
                let dataset = $(e.currentTarget).closest('.cart-voucher__code')[0].dataset
                voucherHandling.handleVoucherDeletion(dataset.code, dataset.url);
            }
            navigation.setGreyout(false);
            tooltip.closest('.cart-voucher__code--inner').removeClass('cart-voucher__input--highlighted');
            tooltip.tooltip('dispose');
        });

        $(document).on('click', '#js-cart-voucher__submit', function (e) {
            e.preventDefault();
            voucherHandling.handleVoucherAdd();
        });

        $(document).on('input', '#js-cart-voucher__input-field', function (e) {
            const submitButton = $('#js-cart-voucher__submit');

            if (e.currentTarget.value === '') {
                submitButton.addClass('d-none');
            } else {
                submitButton.removeClass('d-none');
            }
        });

        $(document).on('keypress', '#js-cart-voucher__input-field', function (e) {
            if (e.keyCode === 13) {
                e.preventDefault();
                voucherHandling.handleVoucherAdd();
            }
        });
    }
};

$(() => {
    voucherHandling.setupVoucherHandling();
});

export default voucherHandling;
